import {
  contactTypeOption,
  countries, degreeTypeOption, entityNumberTypeOption,
  entityRoleOption, issuerLocationTypeOption,
  lotNumberQualifierOption,
  processingCodeOption,
  programCodeOption,
  sourceTypeOption,
  vneDeclarationOption,
  vneBondExemptionOption,
  vneVinSerialNumberTypeOption,
  vneTypeOption,
  vneImportCodeOption,
  vneImportCode3520_1Option,
  vneIndustryCodeOption,
  temperatureQualifierOption,
  usStates,
  yesNoOption
} from "./options";
import { INTENDED_USE_CODES_REQUIRING_DESCRIPTION } from '../constants';

const pgaFdaHeader = [
  {
    name: 'programCode',
    label: 'Program Code',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  },
  {
    name: 'processingCode',
    label: 'Processing Code',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  },
  {
    name: 'intendedUseCode',
    label: 'Intended Use Code',
    type: 'text',
    maxLength: 16,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  },
  {
    name: 'intendedUseDescription',
    label: 'Intended Use Description',
    type: 'text',
    maxLength: 21,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
    condition: (formData, sectionData) => INTENDED_USE_CODES_REQUIRING_DESCRIPTION.includes(sectionData?.intendedUseCode),
  },
  {
    name: 'productNumber',
    label: 'Product Number',
    type: 'text',
    maxLength: 19,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  },
  {
    name: 'tradeNameBrandName',
    label: 'Trade Name/Brand Name',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  },
  {
    name: 'productDescription',
    label: 'Product Description',
    type: 'text',
    maxLength: 57,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
    sizeProp: { xs: 12, sm: 12, lg: 6, xl: 6 }
  },
  {
    name: 'arrivalDateTime',
    label: 'Arrival Date Time',
    type: 'datetime',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  },
  {
    name: 'portOfArrival',
    label: 'Port of Arrival',
    type: 'text',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  },
  {
    name: 'firmsCode',
    label: 'FIRMS Code',
    type: 'text',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  },
  {
    name: 'pnConfirmationNumber',
    label: 'PN Confirmation Number',
    type: 'text',
    maxLength: 33,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  }
]

const fdaCountryOrigin = [
  {
    name: 'country',
    label: 'Country',
    type: 'auto',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'sourceType',
    label: 'Source Type',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const fdaPackaging = [
  {
    name: 'qualifier',
    label: 'Qualifier',
    type: 'number',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'quantity',
    label: 'Quantity',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'unit',
    label: 'Unit',
    type: 'text',
    maxLength: 5,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const fdaAffirmationCompliance = [
  {
    name: 'complianceCode',
    label: 'Compliance Code',
    type: 'text',
    maxLength: 5,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'complianceDesc',
    label: 'Compliance Description',
    type: 'text',
    maxLength: 30,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const fdaLotInformation = [
  {
    name: 'lotNumberQualifier',
    label: 'Lot Number Qualifier',
    type: 'auto',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'lotNumber',
    label: 'Lot Number',
    type: 'text',
    maxLength: 25,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'pgaLineValue',
    label: 'PGA Line Value',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'temperatureQualifier',
    label: 'Temperature Qualifier',
    type: 'auto',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const fdaLotInformationDRU = [
  {
    name: 'productionDateStart',
    label: 'Production Date Start',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'productionDateEnd',
    label: 'Production Date End',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'temperature',
    label: 'Temperature',
    type: 'number',
    maxLength: 6,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'degreeType',
    label: 'Degree Type',
    type: 'auto',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'tempRecordingLocation',
    label: 'Temp Recording Location',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const fdaPartiesPointContact = [
  {
    name: 'saveTradePartner',
    label: 'Save party to Trade Partner',
    type: 'checkbox',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'partyMasterName',
    label: 'Profile Name',
    type: 'text',
    maxLength: 50,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
    requiredCondition: (formData, sectionData) => sectionData?.saveTradePartner === true,
  },
    {
    name: 'partyLookup',
    label: 'Party Lookup',
    type: 'lookupButton',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    type: 'new',
    ignoreColumn: true,
  },
  {
    name: 'entityRole',
    label: 'Entity Role',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'entityName',
    label: 'Entity Name',
    type: 'text',
    maxLength: 32,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'entityNumber',
    label: 'Entity Number',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'entityNumberType',
    label: 'Entity Number Type',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'entityAddress1',
    label: 'Entity Address 1',
    type: 'text',
    maxLength: 23,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'entityAddress2',
    label: 'Entity Address 2',
    type: 'text',
    maxLength: 32,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'apartmentSuiteNumber',
    label: 'Apartment/Suite Number',
    type: 'text',
    maxLength: 5,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'postalCode',
    label: 'Postal Code',
    type: 'text',
    maxLength: 9,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'country',
    label: 'Country',
    type: 'auto',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'stateProvince',
    label: 'State/Province',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'city',
    label: 'City',
    type: 'text',
    maxLength: 21,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'contactType',
    label: 'Contact Type',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'contactName',
    label: 'Contact Name',
    type: 'text',
    maxLength: 23,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'contactTelephone',
    label: 'Contact Telephone',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'contactEmail',
    label: 'Contact Email',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  }
]

const fdaLACF = [
  {
    name: 'canDimensions1',
    label: 'Can Dimensions #1',
    type: 'number',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaLACF'
  },
  {
    name: 'canDimensions2',
    label: 'Can Dimensions #2',
    type: 'number',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaLACF'
  },
  {
    name: 'canDimensions3',
    label: 'Can Dimensions #3',
    type: 'number',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaLACF'
  },
  {
    name: 'packageTrackingNumber',
    label: 'Package Tracking Number',
    type: 'text',
    maxLength: 50,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaLACF'
  },
  {
    name: 'carrierScacIata',
    label: "Carrier/Courier's SCAC/IATA",
    type: 'text',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaLACF'
  }
]

const fdaPrivateOwnedVehicleInformation = [
  {
    name: 'vehicleLicensePlateNumber',
    label: 'Vehicle License Plate Number',
    type: 'text',
    maxLength: 33,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaVehicle'
  },

  {
    name: 'issuerName',
    label: 'Issuer Name',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaVehicle'
  },
  {
    name: 'issuerLocationType',
    label: 'Issuer Location Type',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaVehicle'
  },
  {
    name: 'issuerLocationCode',
    label: 'Issuer Location Code',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaVehicle'
  },
  {
    name: 'issuerLocationName',
    label: 'Issuer Location Name',
    type: 'text',
    maxLength: 25,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaVehicle'
  }
]

const fdaConstituent = [
  {
    name: 'constituentName',
    label: 'Name',
    type: 'text',
    maxLength: 51,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'constituentQuantity',
    label: 'Quantity',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'constituentUnit',
    label: 'Unit',
    type: 'text',
    maxLength: 5,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'percent',
    label: 'Percent',
    type: 'number',
    maxLength: 7,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'isActiveRemarks',
    label: 'Is Active',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const fdaContainer = [
  {
    name: 'containerNum',
    label: 'Container Number',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const fdaRemark = [
  {
    name: 'remarks',
    label: 'Remarks',
    type: 'text',
    maxLength: 68,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaRemarks'
  }
]

const pgaEpaVneHeader = [
  {
    name: 'vneType',
    label: 'V&E Type',
    type: 'auto description',
    maxLength: 6,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'vneHeader',
  },
  {
    name: 'productDescription',
    label: 'Product Description',
    type: 'text',
    maxLength: 70,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'vneHeader',
    sizeProp: { xs: 12, sm: 12, lg: 6, xl: 6 },
  },
  {
    name: 'disDocumentSubmitted',
    label: 'DIS Document Submitted',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'vneHeader',
  },
  {
    name: 'vneImportCode',
    label: 'Import Code',
    type: 'auto',
    maxLength: 3, // 3520-1: 1-2 letters; 3520-21: up to 3 chars (e.g. '24a')
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'vneHeader',
    sizeProp: { xs: 12, sm: 12, lg: 12, xl: 12 },
  },
  {
    name: 'vneIndustryCode',
    label: 'Industry Code',
    type: 'auto',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'vneHeader',
    sizeProp: { xs: 12, sm: 12, lg: 12, xl: 12 },
  },
  {
    name: 'vneBondExemption',
    label: 'Vehicles and Engines Bond Exemption',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'vneHeader',
  },
  {
    name: 'vneRegulatedCitedForOtherExemption',
    label: 'EPA Vehicles and Engines Regulation Cited for other exemption',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'vneHeader',
  },
  {
    type: 'new',
    section: 'vneHeader',
  },
  {
    name: 'vneTestGroupNameNumber',
    label: 'Test Group Name/Number',
    type: 'text',
    maxLength: 33,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'vneHeader',
  },
  {
    name: 'vneBondPolicyNumber',
    label: 'Bond Policy Number',
    type: 'text',
    maxLength: 33,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'vneHeader',
  },
  {
    name: 'vneExemptionNumber',
    label: 'V&E Exemption Number',
    type: 'text',
    maxLength: 33,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'vneHeader',
  },

  {
    type: 'new',
    section: 'vneHeader',
  },

  {
    name: 'declaration',
    label: 'Designates that the information provided is correct and all required information has been provided',
    type: 'checkboxvalue',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'vneHeader',
    sizeProp: { xs: 12, sm: 12, lg: 12, xl: 12 },
  },
  {
    name: 'signatureDate',
    label: 'Date of Signature',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'vneHeader',
  },
]

const vnePartiesPointContact = [
  {
    name: 'saveTradePartner',
    label: 'Save party to Trade Partner',
    type: 'checkbox',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'partyMasterName',
    label: 'Profile Name',
    type: 'text',
    maxLength: 50,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
    requiredCondition: (formData, sectionData) => sectionData?.saveTradePartner === true,
  },
    {
    name: 'partyLookup',
    label: 'Party Lookup',
    type: 'lookupButton',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    type: 'new',
    ignoreColumn: true,
  },
  {
    name: 'entityRole',
    label: 'Entity Role',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'entityNumber',
    label: 'Entity Number',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'entityNumberType',
    label: 'Entity Number Type',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    type: 'new',
    ignoreColumn: true,
  },
  {
    name: 'entityName',
    label: 'Entity Name',
    type: 'text',
    maxLength: 32,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'entityAddress1',
    label: 'Entity Address 1',
    type: 'text',
    maxLength: 23,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'entityAddress2',
    label: 'Entity Address 2',
    type: 'text',
    maxLength: 32,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'apartmentSuiteNumber',
    label: 'Apartment/Suite Number',
    type: 'text',
    maxLength: 5,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'postalCode',
    label: 'Postal Code',
    type: 'text',
    maxLength: 9,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'country',
    label: 'Country',
    type: 'auto',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'stateProvince',
    label: 'State/Province',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'city',
    label: 'City',
    type: 'text',
    maxLength: 21,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'contactName',
    label: 'Contact Name',
    type: 'text',
    maxLength: 23,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'contactTelephone',
    label: 'Contact Telephone',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'contactEmail',
    label: 'Contact Email',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  }
]

const vneRemark = [
  {
    name: 'remarks',
    label: 'Remarks',
    type: 'text',
    maxLength: 68,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'vneRemarks'
  }
]

const vneVehiclesAndEngine = [
  {
    name: 'vneModel',
    label: 'Model',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'vneVehiclesAndEngines',
  },
  {
    name: 'vneManufactureDate',
    label: 'Manufacture Date',
    type: 'month',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'vneVehiclesAndEngines',
  },
  {
    type: 'new',
    section: "vneVehiclesAndEngines"
  },
  {
    name: 'vneVinSerialNumberType',
    label: 'VIN/Serial Number Type',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'vneVehiclesAndEngines',
  },
  {
    name: 'vneVinSerialNumberList',
    label: 'VIN/Serial Number',
    type: 'multiText',
    maxLength: 17,
    placeholder: '',
    defaultValue: [''],
    required: false,
    disabled: false,
    icon: undefined,
    section: 'vneVehiclesAndEngines',
    addButtonLabel: 'Add VIN/Serial Number',
  },
]

const vneVehiclesAndEngineComponents = [
  {
    name: 'vneComponentName',
    label: 'Component Name',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'vneManufactureDate',
    label: 'Manufacture Date',
    type: 'datetime',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'vneVinSerialNumberType',
    label: 'VIN/Serial Number Type',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'vneVinSerialNumber',
    label: 'VIN/Serial Number ',
    type: 'text',
    maxLength: 17,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
]

const countryOriginOptionsMap = {
  country: countries,
  sourceType: sourceTypeOption
}

const lotInfoOptionsMap = {
  lotNumberQualifier: lotNumberQualifierOption,
  temperatureQualifier: temperatureQualifierOption,
  degreeType: degreeTypeOption
}

const partiesOptionsMap = {
  entityRole: entityRoleOption,
  entityNumberType: entityNumberTypeOption,
  stateProvince: usStates,
  country: countries,
  contactType: contactTypeOption,
  partyLookup: [], // Will be populated dynamically
}

// ─── CPSC ─────────────────────────────────────────────────────────────────────

const cpscProcessingCodeOption = [
  { value: 'REF', description: 'REF - With Product Registry (Reference PGA Message Set)' },
  { value: 'FCP', description: "FCP - Full CPSC for Children's Product Certificate" },
  { value: 'FGC', description: 'FGC - Full CPSC for General Product Certificate' },
]

const cpscDeclarationOption = [
  { value: 'CPY', description: 'Yes' },
  { value: 'CPN', description: 'No' },
]

const cpscInspectionLabTestingStatusOption = [
  { value: 'L', description: 'Lab testing previously performed' },
  { value: 'N', description: 'No laboratory testing performed' },
]

const cpscEntityRoleOption = [
  { value: 'CE',  description: 'Certifying Entity' },
  { value: 'ITL', description: 'Independent ThirdParty Laboratory' },
  { value: 'LAB', description: 'Laboratory' },
  { value: 'MF',  description: 'Manufacturer of goods' },
  { value: 'NOL', description: 'No Lab testing required' },
  { value: 'PK',  description: 'Point of Contact' },
]

const cpscLotNumberQualifierOption = [
  { value: '1', description: 'Manufacturer' },
  { value: '3', description: 'Grower' },
]

const cpscProductNumberTypeOption = [
  { value: 'MN',  description: 'MN - Model Number' },
  { value: 'SE',  description: 'SE - Serial Number' },
  { value: 'RN',  description: 'RN - Registered Number' },
  { value: 'ALT', description: 'ALT - Alternate Identifier' },
]

// ── Header inline fields ──────────────────────────────────────────────────────
// cpscHeaderCommon   – always visible (processingCode, intendedUseCode/Desc, productDescription)
// cpscHeaderNonRef   – hidden when processingCode === 'REF'
// cpscHeaderRef      – visible only when processingCode === 'REF'
// cpscHeaderFcpFgc   – visible only when processingCode === 'FCP' or 'FGC'
const cpscHeader = [
  {
    name: 'processingCode',
    label: 'Processing Code',
    type: 'auto description',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
    section: 'cpscHeaderCommon',
  },
  {
    name: 'intendedUseCode',
    label: 'Intended Use Code',
    type: 'text',
    maxLength: 16,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'cpscHeaderCommon',
  },
  {
    name: 'intendedUseDescription',
    label: 'Intended Use Description',
    type: 'text',
    maxLength: 21,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'cpscHeaderCommon',
    condition: (formData, sectionData) => INTENDED_USE_CODES_REQUIRING_DESCRIPTION.includes(sectionData?.intendedUseCode),
  },
  {
    name: 'productDescription',
    label: 'Product Description',
    type: 'text',
    maxLength: 127,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'cpscHeaderCommon',
    sizeProp: { xs: 12, sm: 12, lg: 6, xl: 6 },
    helperText: 'Max 127 chars: first 70 in OI; 71–127 in PG10',
  },
  // ── REF conditional fields (section: cpscHeaderRef) ───────────────────────
  {
    name: 'productId',
    label: 'Product ID',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'cpscHeaderRef',
  },
  {
    name: 'versionId',
    label: 'Version ID',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'cpscHeaderRef',
  },
  {
    name: 'certifierId',
    label: 'Certifier ID',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'cpscHeaderRef',
  },
  // ── FCP / FGC conditional fields (section: cpscHeaderFcpFgc) ─────────────
  {
    name: 'gtin',
    label: 'GS1 Global Trade Item Number (GTIN)',
    type: 'text',
    maxLength: 14,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'cpscHeaderFcpFgc',
  },
  {
    name: 'upc',
    label: 'UPC (Universal Product Code)',
    type: 'text',
    maxLength: 12,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'cpscHeaderFcpFgc',
  },
  {
    name: 'stockKeepingUnit',
    label: 'Stock Keeping Unit',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'cpscHeaderFcpFgc',
  },
  // ── Inspection / Testing (hidden when REF) ────────────────────────────────
  {
    name: 'inspectionLabTestingStatus',
    label: 'Inspection/Laboratory Testing Status',
    type: 'auto description',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'cpscHeaderNonRef',
  },
  {
    name: 'dateOfPreviousTesting',
    label: 'Date of Previous Testing',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'cpscHeaderNonRef',
  },
  {
    name: 'labTestReportId',
    label: 'Lab Test Report ID',
    type: 'text',
    maxLength: 50,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'cpscHeaderNonRef',
  },
  {
    name: 'labTestReportUrl',
    label: 'Lab Test Report URL',
    type: 'text',
    maxLength: 200,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'cpscHeaderNonRef',
  },
  {
    name: 'accessKeyLabTestReportUrl',
    label: 'Access Key to Lab Test Report URL',
    type: 'text',
    maxLength: 50,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'cpscHeaderNonRef',
  },
  {
    name: 'componentPartDescription',
    label: 'Component Part Description',
    type: 'text',
    maxLength: 70,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'cpscHeaderNonRef',
    sizeProp: { xs: 12, sm: 12, lg: 6, xl: 6 },
  },
  {
    name: 'declaration',
    label: 'The certifying entity certifies that the finished product(s) covered by this certificate comply with the rules, bans, standards, and regulations stated herein, and that the information in this certificate is true and accurate to the best of my knowledge, information, and belief. The certifying entity understands and acknowledges that it is a United States federal crime to knowingly and willfully make any materially false, fictitious, or fraudulent statements, representations, or omissions, on this certificate.',
    type: 'checkboxvalue',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'cpscHeaderNonRef',
    sizeProp: { xs: 12, sm: 12, lg: 12, xl: 12 },
  },
]

// ── Products table rows ───────────────────────────────────────────────────────
const cpscProductFields = [
  {
    name: 'brandName',
    label: 'Brand Name',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'productName',
    label: 'Product Name',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'manufactureDate',
    label: 'Manufacture Date',
    type: 'monthyear',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'productNumberType',
    label: 'Product Number Type',
    type: 'auto description',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'productNumber',
    label: 'Product Number',
    type: 'text',
    maxLength: 30,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
]

// ── Parties & Point of Contact table rows ─────────────────────────────────────
const cpscPartiesPointContact = [
  {
    name: 'saveTradePartner',
    label: 'Save party to Trade Partner',
    type: 'checkbox',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'partyMasterName',
    label: 'Profile Name',
    type: 'text',
    maxLength: 50,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
    requiredCondition: (formData, sectionData) => sectionData?.saveTradePartner === true,
  },
  {
    name: 'partyLookup',
    label: 'Party Lookup',
    type: 'lookupButton',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    type: 'new',
    ignoreColumn: true,
  },
  {
    name: 'entityRole',
    label: 'Entity Role',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entityName',
    label: 'Entity Name',
    type: 'text',
    maxLength: 32,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entityNumber',
    label: 'Entity Number',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entityNumberType',
    label: 'Entity Number Type',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'entityAddress1',
    label: 'Entity Address 1',
    type: 'text',
    maxLength: 23,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'entityAddress2',
    label: 'Entity Address 2',
    type: 'text',
    maxLength: 32,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'apartmentSuiteNumber',
    label: 'Apartment/Suite Number',
    type: 'text',
    maxLength: 5,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'postalCode',
    label: 'Postal Code',
    type: 'text',
    maxLength: 9,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'country',
    label: 'Country',
    type: 'auto',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'stateProvince',
    label: 'State/Province',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'city',
    label: 'City',
    type: 'text',
    maxLength: 21,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'contactTelephone',
    label: 'Contact Telephone',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'contactEmail',
    label: 'Contact Email',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
]

// ── Lot Information table rows ────────────────────────────────────────────────
const cpscLotInformation = [
  {
    name: 'lotNumberQualifier',
    label: 'Lot Number Qualifier',
    type: 'auto description',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'lotNumber',
    label: 'Lot Number',
    type: 'text',
    maxLength: 25,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'productionDateStart',
    label: 'Production Date Start',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'productionDateEnd',
    label: 'Production Date End',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  }
]

// ── Optional inline fields ────────────────────────────────────────────────────
const cpscOptionalFields = [
  {
    name: 'citation',
    label: 'Citation',
    type: 'text',
    maxLength: 50,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'cpscOptional',
  },
]

// ── Options maps ──────────────────────────────────────────────────────────────
const cpscHeaderOptionsMap = {
  processingCode:              cpscProcessingCodeOption,
  inspectionLabTestingStatus:  cpscInspectionLabTestingStatusOption,
  declaration:                 cpscDeclarationOption
}

const cpscPartiesOptionsMap = {
  entityRole:       cpscEntityRoleOption,
  entityNumberType: entityNumberTypeOption,
  stateProvince:    usStates,
  country:          countries,
  partyLookup:      [],
}

const cpscLotOptionsMap = {
  lotNumberQualifier: cpscLotNumberQualifierOption,
}

const cpscProductOptionsMap = {
  productNumberType: cpscProductNumberTypeOption,
}

// ─── EPA PESTICIDE ────────────────────────────────────────────────────────────

// Options
const epaPesticideProgramCodeOption = [
  { value: 'PS1', description: 'PS1 - Registered Pesticides' },
  { value: 'PS2', description: 'PS2 - Pesticides - Devices' },
  { value: 'PS3', description: 'PS3 - Pesticides - Other' },
]

const epaPesticideDeclarationOption = [
  { value: 'EP3', description: 'Yes' },
]

const epaPesticideProductNumberTypeOption = [
  { value: 'CAS', description: 'CAS - Chemical Abstract Service Number' },
  { value: 'PC',  description: 'PC - Pesticides Control Number' },
]

const epaPesticideEntityRoleOption = [
  { value: 'IM',  description: 'IM - Importer' },
  { value: 'CAR', description: 'CAR - Carrier' },
  { value: 'DEQ', description: 'DEQ - Shipper' },
  { value: 'EPN', description: 'EPN - EPA Producer Establishment Number' },
  { value: 'LG',  description: 'LG - Location of Goods' },
  { value: 'CB',  description: 'CB - Customs Broker' },
  { value: 'CI',  description: 'CI - Certifying Individual' },
  { value: 'NP',  description: 'NP - Notifying Party' },
]

const epaPesticidePackagingUomOption = [
  { value: 'AE',  description: 'AE - Aerosol' },
  { value: 'TY',  description: 'TY - Tank, Cylindrical' },
  { value: 'VL',  description: 'VL - Bulk Liquid' },
  { value: 'BX',  description: 'BX - Box' },
  { value: 'CA',  description: 'CA - Can, Rectangle' },
  { value: 'CX',  description: 'CX - Can, Cylindrical' },
  { value: 'TU',  description: 'TU - Tube' },
  { value: 'TK',  description: 'TK - Tank, Rectangular' },
  { value: 'CON', description: 'CON - Container' },
  { value: 'M3',  description: 'M3 - Cubic Meters Volume' },
  { value: 'GAL', description: 'GAL - Gallons' },
  { value: 'L',   description: 'L - Liters' },
  { value: 'KG',  description: 'KG - Kilogram' },
  { value: 'BO',  description: 'BO - Bottle, Non-protected, Cylindrical' },
  { value: 'BQ',  description: 'BQ - Bottle, Protected, Cylindrical' },
]

const epaPesticideWeightUomOption = [
  { value: 'G',   description: 'G - Gram' },
  { value: 'KG',  description: 'KG - Kilogram' },
  { value: 'MG',  description: 'MG - Milligram' },
  { value: 'OZ',  description: 'OZ - Ounces' },
  { value: 'QTL', description: 'QTL - Quarts' },
  { value: 'ML',  description: 'ML - Milliliters' },
  { value: 'GAL', description: 'GAL - Gallons' },
]

const epaPesticideDisDocumentSubmittedOption = [
  { value: 'Y', description: 'Yes - Image submitted via DIS' },
  { value: 'N', description: 'No' },
]

// ── Header inline fields (section: 'epaPesticideHeader') ─────────────────────
const epaPesticideHeader = [
  {
    name: 'programCode',
    label: 'Program Code',
    type: 'auto description',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
    section: 'epaPesticideHeader',
  },
  {
    name: 'disDocumentSubmitted',
    label: 'DIS Document Submitted',
    type: 'auto description',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'epaPesticideHeader',
  },
  {
    name: 'intendedUseCode',
    label: 'Intended Use Code',
    type: 'text',
    maxLength: 16,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'epaPesticideHeader',
  },
  {
    name: 'intendedUseDescription',
    label: 'Intended Use Description',
    type: 'text',
    maxLength: 21,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'epaPesticideHeader',
    condition: (formData, sectionData) => INTENDED_USE_CODES_REQUIRING_DESCRIPTION.includes(sectionData?.intendedUseCode),
  },
  {
    name: 'productDescription',
    label: 'Product Description',
    type: 'text',
    maxLength: 70,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'epaPesticideHeader',
    sizeProp: { xs: 12, sm: 12, lg: 6, xl: 6 },
    helperText: 'Commercial Description (OI field, 70 chars)',
  },
  {
    name: 'tradeNameBrandName',
    label: 'Trade Name/Brand Name',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'epaPesticideHeader',
  },
  {
    name: 'epaRegistrationNumber',
    label: 'EPA Registration Number',
    type: 'text',
    maxLength: 33,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'epaPesticideHeader',
  },
  {
    name: 'casNumber',
    label: 'Chemical Abstract Service Number',
    type: 'text',
    maxLength: 19,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'epaPesticideHeader',
  },
  {
    name: 'pesticidesControlNumber',
    label: 'Pesticides Control Number',
    type: 'text',
    maxLength: 19,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'epaPesticideHeader',
  },
  { name: '_declarationBreak', type: 'new', section: 'epaPesticideHeader' },
  {
    name: 'declaration',
    label: 'Designates that the information provided is correct and all required information has been provided',
    type: 'checkboxvalue',
    defaultValue: '',
    required: true,
    disabled: false,
    autoFillDateField: 'signatureDate',
    section: 'epaPesticideHeader',
    sizeProp: { xs: 12 },
  },
  {
    name: 'signatureDate',
    label: 'Date of Signature',
    type: 'datetime',
    defaultValue: '',
    required: false,
    section: 'epaPesticideHeader',
    sizeProp: { xs: 'auto' },
  },
]

// ── Constituent (C) table rows ────────────────────────────────────────────────
const epaPesticideConstituent = [
  {
    name: 'constituentName',
    label: 'Name',
    type: 'text',
    maxLength: 51,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'percent',
    label: 'Percent',
    type: 'number',
    maxLength: 7,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'isActive',
    label: 'Active?',
    type: 'auto description',
    maxLength: 1,
    placeholder: 'Please select',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
]

// ── Parties & Point of Contact table rows ─────────────────────────────────────
const epaPesticidePartiesPointContact = [
  {
    name: 'saveTradePartner',
    label: 'Save party to Trade Partner',
    type: 'checkbox',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'partyMasterName',
    label: 'Profile Name',
    type: 'text',
    maxLength: 50,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
    requiredCondition: (formData, sectionData) => sectionData?.saveTradePartner === true,
  },
  {
    name: 'partyLookup',
    label: 'Party Lookup',
    type: 'lookupButton',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    type: 'new',
    ignoreColumn: true,
  },
  {
    name: 'entityRole',
    label: 'Entity Role',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entityName',
    label: 'Entity Name',
    type: 'text',
    maxLength: 32,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entityNumber',
    label: 'Entity Number',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entityNumberType',
    label: 'Entity Number Type',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'entityAddress1',
    label: 'Entity Address 1',
    type: 'text',
    maxLength: 23,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'entityAddress2',
    label: 'Entity Address 2',
    type: 'text',
    maxLength: 32,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'apartmentSuiteNumber',
    label: 'Apartment/Suite Number',
    type: 'text',
    maxLength: 5,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'postalCode',
    label: 'Postal Code',
    type: 'text',
    maxLength: 9,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'country',
    label: 'Country',
    type: 'auto',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'stateProvince',
    label: 'State/Province',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'city',
    label: 'City',
    type: 'text',
    maxLength: 21,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'contactName',
    label: 'Contact Name',
    type: 'text',
    maxLength: 23,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'contactTelephone',
    label: 'Contact Telephone',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'contactEmail',
    label: 'Contact Email',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
]

// ── Packaging table rows ──────────────────────────────────────────────────────
const epaPesticidePackaging = [
  {
    name: 'qualifier',
    label: 'Qualifier',
    type: 'number',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'quantity',
    label: 'Quantity',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'unit',
    label: 'Unit',
    type: 'auto',
    maxLength: 5,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
]

// ── Weight table rows ─────────────────────────────────────────────────────────
const epaPesticideWeight = [
  {
    name: 'weight',
    label: 'Weight',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'unit',
    label: 'Unit',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
]

// ── Optional inline fields (section: 'epaPesticideOptional') ─────────────────
const epaPesticideOptional = [
  {
    name: 'remarks',
    label: 'Remarks',
    type: 'text',
    maxLength: 68,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'epaPesticideOptional',
  },
  {
    name: 'epaNoticeOfArrival',
    label: 'EPA Notice of Arrival of Pesticides and Devices',
    type: 'text',
    maxLength: 68,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'epaPesticideOptional',
  },
]

// ── Options maps ──────────────────────────────────────────────────────────────
const epaPesticideHeaderOptionsMap = {
  programCode:          epaPesticideProgramCodeOption,
  declaration:          epaPesticideDeclarationOption,
  productNumberType:    epaPesticideProductNumberTypeOption,
  disDocumentSubmitted: epaPesticideDisDocumentSubmittedOption,
}

const epaPesticideConstituentOptionsMap = {
  isActive: yesNoOption,
}

const epaPesticidePartiesOptionsMap = {
  entityRole:       epaPesticideEntityRoleOption,
  entityNumberType: entityNumberTypeOption,
  stateProvince:    usStates,
  country:          countries,
  partyLookup:      [],
}

const epaPesticidePackagingOptionsMap = {
  unit: epaPesticidePackagingUomOption,
}

const epaPesticideWeightOptionsMap = {
  unit: epaPesticideWeightUomOption,
}

// ─── EPA HFC (Hydrofluorocarbons — AIM Act) ───────────────────────────────────

// ── Option arrays ──────────────────────────────────────────────────────────────

const epaHfcDisDocumentSubmittedOption = [
  { value: 'Y', description: 'Yes - Image submitted via DIS' },
  { value: 'N', description: 'No' },
]

const epaHfcItemTypeOption = [
  { value: 'P', description: 'P - Product' },
  { value: 'C', description: 'C - Component' },
]

const epaHfcEntityRoleOption = [
  { value: 'IM',  description: 'IM - Importer' },
  { value: 'CN',  description: 'CN - Consignee' },
  { value: 'CAR', description: 'CAR - Carrier' },
  { value: 'DEQ', description: 'DEQ - Shipper' },
  { value: 'LG',  description: 'LG - Location of Goods' },
  { value: 'CB',  description: 'CB - Customs Broker' },
  { value: 'CI',  description: 'CI - Certifying Individual' },
  { value: 'NP',  description: 'NP - Notifying Party' },
  { value: 'MF',  description: 'MF - Manufacturer' },
]

const epaHfcPackagingUomOption = [
  { value: 'AE',  description: 'AE - Aerosol' },
  { value: 'TY',  description: 'TY - Tank, Cylindrical' },
  { value: 'VL',  description: 'VL - Bulk Liquid' },
  { value: 'BX',  description: 'BX - Box' },
  { value: 'CA',  description: 'CA - Can, Rectangle' },
  { value: 'CX',  description: 'CX - Can, Cylindrical' },
  { value: 'TU',  description: 'TU - Tube' },
  { value: 'TK',  description: 'TK - Tank, Rectangular' },
  { value: 'CON', description: 'CON - Container' },
  { value: 'M3',  description: 'M3 - Cubic Meters Volume' },
  { value: 'GAL', description: 'GAL - Gallons' },
  { value: 'L',   description: 'L - Liters' },
  { value: 'KG',  description: 'KG - Kilogram' },
  { value: 'BO',  description: 'BO - Bottle, Non-protected, Cylindrical' },
  { value: 'BQ',  description: 'BQ - Bottle, Protected, Cylindrical' },
]

const epaHfcWeightUomOption = [
  { value: 'KG',  description: 'Kilogram' },
]

// ── Header inline fields (section: 'epaHfcHeader') ───────────────────────────
const epaHfcHeader = [
  {
    name: 'itemType',
    label: 'Item Type',
    type: 'auto description',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'epaHfcHeader',
  },
  {
    name: 'productDescription',
    label: 'Product Description',
    type: 'text',
    maxLength: 70,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'epaHfcHeader',
    sizeProp: { xs: 12, sm: 12, lg: 6, xl: 6 },
  },
  {
    name: 'disDocumentSubmitted',
    label: 'DIS Document Submitted',
    type: 'auto description',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'epaHfcHeader',
  },
  {
    name: 'casNumber',
    label: 'Chemical Abstract Service Number',
    type: 'text',
    maxLength: 19,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'epaHfcHeader',
  },
  {
    name: 'ashraeNumber',
    label: 'ASHRAE Number',
    type: 'text',
    maxLength: 19,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'epaHfcHeader',
  },
  {
    name: 'hfcDeclaration',
    label: 'I certify that all chemical substances in this shipment comply with all applicable rules or orders under TSCA and that I am not offering a chemical substance for entry in violation of TSCA or any applicable rule or order under TSCA.',
    type: 'checkboxvalue',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'epaHfcHeader',
    sizeProp: { xs: 12, sm: 12, lg: 9, xl: 9 },
  },
]

// ── Constituent table rows ─────────────────────────────────────────────────────
const epaHfcConstituent = [
  {
    name: 'constituentName',
    label: 'Name',
    type: 'text',
    maxLength: 51,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'percent',
    label: 'Percent',
    type: 'number',
    maxLength: 7,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
]

// ── Parties & Point of Contact table rows ─────────────────────────────────────
const epaHfcPartiesPointContact = [
  {
    name: 'saveTradePartner',
    label: 'Save party to Trade Partner',
    type: 'checkbox',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'partyMasterName',
    label: 'Profile Name',
    type: 'text',
    maxLength: 50,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
    requiredCondition: (formData, sectionData) => sectionData?.saveTradePartner === true,
  },
  {
    name: 'partyLookup',
    label: 'Party Lookup',
    type: 'lookupButton',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    type: 'new',
    ignoreColumn: true,
  },
  {
    name: 'entityRole',
    label: 'Entity Role',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entityName',
    label: 'Entity Name',
    type: 'text',
    maxLength: 32,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entityNumber',
    label: 'Entity Number',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entityNumberType',
    label: 'Entity Number Type',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'entityAddress1',
    label: 'Entity Address 1',
    type: 'text',
    maxLength: 23,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'entityAddress2',
    label: 'Entity Address 2',
    type: 'text',
    maxLength: 32,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'apartmentSuiteNumber',
    label: 'Apartment/Suite Number',
    type: 'text',
    maxLength: 5,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'postalCode',
    label: 'Postal Code',
    type: 'text',
    maxLength: 9,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'country',
    label: 'Country',
    type: 'auto',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'stateProvince',
    label: 'State/Province',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'city',
    label: 'City',
    type: 'text',
    maxLength: 21,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'contactName',
    label: 'Contact Name',
    type: 'text',
    maxLength: 23,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'contactTelephone',
    label: 'Contact Telephone',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'contactEmail',
    label: 'Contact Email',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
]

// ── Packaging table rows ──────────────────────────────────────────────────────
const epaHfcPackaging = [
  {
    name: 'qualifier',
    label: 'Qualifier',
    type: 'number',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'quantity',
    label: 'Quantity',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'unit',
    label: 'Unit',
    type: 'auto',
    maxLength: 5,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
]

// ── Weight table rows ─────────────────────────────────────────────────────────
const epaHfcWeight = [
  {
    name: 'weight',
    label: 'Weight',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'unit',
    label: 'Unit',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
]

// ── Optional inline fields (section: 'epaHfcOptional') ───────────────────────
const epaHfcOptional = [
  {
    name: 'remarks',
    label: 'Remarks',
    type: 'text',
    maxLength: 68,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'epaHfcOptional',
  },
]

// ── Containers table rows ─────────────────────────────────────────────────────
const epaHfcContainer = [
  {
    name: 'containerNum',
    label: 'Container Number',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
]

// ── Gross/Net Unit of Measure table rows ──────────────────────────────────────
const epaHfcGrossNetUom = [
  {
    name: 'weight',
    label: 'Quantity',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'unit',
    label: 'Unit',
    type: 'auto',
    maxLength: 5,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
]

// ── Options maps ──────────────────────────────────────────────────────────────
const epaHfcDeclarationOption = [
  { value: 'Y', description: 'Yes' },
  { value: 'N', description: 'No' },
]

const epaHfcHeaderOptionsMap = {
  itemType:            epaHfcItemTypeOption,
  disDocumentSubmitted: epaHfcDisDocumentSubmittedOption,
  hfcDeclaration:      epaHfcDeclarationOption,
}

const epaHfcPartiesOptionsMap = {
  entityRole:       epaHfcEntityRoleOption,
  entityNumberType: entityNumberTypeOption,
  stateProvince:    usStates,
  country:          countries,
  partyLookup:      [],
}

const epaHfcPackagingOptionsMap = {
  unit: epaHfcPackagingUomOption,
}

const epaHfcWeightOptionsMap = {
  unit: epaHfcWeightUomOption,
}

const vneHeaderOptionsMap = {
  declaration: vneDeclarationOption,
  vneBondExemption: vneBondExemptionOption,
  vneType: vneTypeOption,
  vneImportCode: vneImportCodeOption,
  vneIndustryCode: vneIndustryCodeOption,
  disDocumentSubmitted : yesNoOption,
}

const vneVehiclesAndEnginesOptionsMap = {
  vneVinSerialNumberType: vneVinSerialNumberTypeOption,
}

export {
  pgaFdaHeader,
  fdaRemark,
  fdaContainer,
  fdaConstituent,
  fdaPrivateOwnedVehicleInformation,
  fdaLACF,
  fdaCountryOrigin,
  fdaPackaging,
  fdaAffirmationCompliance,
  fdaLotInformation,
  fdaLotInformationDRU,
  fdaPartiesPointContact,
  pgaEpaVneHeader,
  vnePartiesPointContact,
  vneRemark,
  vneVehiclesAndEngine,
  vneVehiclesAndEngineComponents,
  countryOriginOptionsMap,
  lotInfoOptionsMap,
  partiesOptionsMap,
  // CPSC
  cpscHeader,
  cpscProductFields,
  cpscPartiesPointContact,
  cpscLotInformation,
  cpscOptionalFields,
  cpscHeaderOptionsMap,
  cpscPartiesOptionsMap,
  cpscLotOptionsMap,
  cpscProductOptionsMap,
  // EPA Pesticide
  epaPesticideHeader,
  epaPesticideConstituent,
  epaPesticidePartiesPointContact,
  epaPesticidePackaging,
  epaPesticideWeight,
  epaPesticideOptional,
  epaPesticideHeaderOptionsMap,
  epaPesticideConstituentOptionsMap,
  epaPesticidePartiesOptionsMap,
  epaPesticidePackagingOptionsMap,
  epaPesticideWeightOptionsMap,
  // EPA HFC
  epaHfcHeader,
  epaHfcConstituent,
  epaHfcContainer,
  epaHfcGrossNetUom,
  epaHfcPartiesPointContact,
  epaHfcOptional,
  epaHfcHeaderOptionsMap,
  epaHfcPartiesOptionsMap,
  epaHfcWeightOptionsMap,
  vneHeaderOptionsMap,
  vneVehiclesAndEnginesOptionsMap
}